export default "__VITE_ASSET__B6Xjt7KX__"